import { useRef, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import "../PdfFatura/PdfFaturaStyle.scss";
import "./PdfComprovativoDesconto.scss";
import moment from "moment/moment";

function PdfComprovativoDesconto({
  comprovativoDescontoData,
  showPreviousPage,
  paperSize = "A4",
}) {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Comprovativos Desconto-${moment(new Date()).format(
      "DD-MM-YYYY",
    )}`,
    onAfterPrint: () => {
      showPreviousPage();
    },
    pageStyle:
      paperSize === "A5"
        ? "@page { size: A5 portrait; }"
        : "@page { size: A4 portrait; }",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    handlePrint();
  }, [handlePrint]);

  // Função para verificar se é isenção total
  const isIsencaoTotal = (paciente) => {
    return (
      paciente.totalBeneficiario + paciente.totalProtese ===
      paciente.desconto + (paciente.majoracao || 0)
    );
  };

  // Função para gerar a mensagem apropriada
  const getMensagem = (paciente) => {
    const isTotal = isIsencaoTotal(paciente);

    if (isTotal) {
      return (
        <>
          Declaramos que foi concedida ao(à) paciente{" "}
          <span className="pdfComprovativoDesconto__body__message__bold">
            {paciente.nome}
          </span>
          , a{" "}
          <span className="pdfComprovativoDesconto__body__message__bold">
            isenção total
          </span>{" "}
          do pagamento do orçamento de tratamento dentário, no valor de{" "}
          {paciente.desconto.toLocaleString("pt-Br")} CVE.
        </>
      );
    } else {
      return (
        <>
          Declaramos que foi concedido ao(à) paciente{" "}
          <span className="pdfComprovativoDesconto__body__message__bold">
            {paciente.nome}
          </span>
          , um desconto no valor de {paciente.desconto.toLocaleString("pt-Br")}{" "}
          CVE, aplicado ao orçamento de tratamento dentário.
        </>
      );
    }
  };

  return (
    <>
      <div ref={componentRef}>
        {comprovativoDescontoData.dados.map((paciente, index) => (
          <div
            key={index}
            className={`pdf-fatura-wrapper ${comprovativoDescontoData.clinica?.configuracoes?.configuracoes?.impressaoPretoEBranco?.ativo ? " pdf-wrapper--pretoebranco" : ""} ${paperSize === "A5" ? "a5-size" : ""}`}
            style={{
              pageBreakAfter:
                index < comprovativoDescontoData.dados.length - 1
                  ? "always"
                  : "auto",
            }}
          >
            <div className="pdf-orcamento-cabecalho" id="pdf-fatura-cabecalho">
              <div className="pdf-orcamento-cabecalho-left">
                <img
                  src={`${process.env.REACT_APP_BACKEND_LINK}/${comprovativoDescontoData.clinica.logotipo}`}
                  alt="Logo da clínica"
                />
              </div>

              <div className="pdf-orcamento-cabecalho-right pdf-fatura-cabecalho-right">
                <span>{comprovativoDescontoData.clinica.nome}</span>
                <span>
                  Telef: {comprovativoDescontoData.clinica.contacto}{" "}
                  {comprovativoDescontoData.clinica.contacto2
                    ? "/" + comprovativoDescontoData.clinica.contacto2
                    : ""}
                  {comprovativoDescontoData.clinica.contacto3
                    ? "/" + comprovativoDescontoData.clinica.contacto3
                    : ""}
                </span>
                <span>{comprovativoDescontoData.clinica.endereco}</span>
                <span>NIF: {comprovativoDescontoData.clinica.nif}</span>
              </div>
            </div>

            <div className="pdfComprovativoDesconto__body">
              <span className="pdfComprovativoDesconto__body__title">
                Declaração de{" "}
                {isIsencaoTotal(paciente) ? "Isenção" : "Desconto"}
              </span>

              <div className="pdfComprovativoDesconto__body__message">
                {getMensagem(paciente)}
              </div>

              <span>Agradecemos antecipadamente pela compreensão.</span>

              <span className="pdfComprovativoDesconto__body__data">
                {comprovativoDescontoData.clinica.ilha},{" "}
                {moment(comprovativoDescontoData.data).format(
                  "DD [de] MMMM [de] YYYY",
                )}
              </span>

              <span className="pdfComprovativoDesconto__body__message__bold pdfComprovativoDesconto__body__nomeClinica">
                {comprovativoDescontoData.clinica.nome}
              </span>

              <hr className="pdfComprovativoDesconto__body__linhaAssinatura" />
            </div>

            <div className="pdf-fatura-rodape">
              <hr />
              <div className="pdf-fatura-rodape__poweredBy">
                Powered by: HealthTech CV
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default PdfComprovativoDesconto;
